/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of the competition
 * @export
 */
export const CompetitionStatus = {
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED'
} as const;
export type CompetitionStatus = typeof CompetitionStatus[keyof typeof CompetitionStatus];


export function instanceOfCompetitionStatus(value: any): boolean {
    for (const key in CompetitionStatus) {
        if (Object.prototype.hasOwnProperty.call(CompetitionStatus, key)) {
            if (CompetitionStatus[key as keyof typeof CompetitionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionStatusFromJSON(json: any): CompetitionStatus {
    return CompetitionStatusFromJSONTyped(json, false);
}

export function CompetitionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionStatus {
    return json as CompetitionStatus;
}

export function CompetitionStatusToJSON(value?: CompetitionStatus | null): any {
    return value as any;
}

export function CompetitionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionStatus {
    return value as CompetitionStatus;
}

